export enum PillVariants {
  GREEN = 'green',
  GOLDEN = 'golden',
  RED = 'red',
  PURPLE = 'purple',
  GREY = 'grey',
}

export type PillVariantsValue = `${PillVariants}`;

export const PillVariantsMapper = {
  [PillVariants.GREEN]: {
    backgroundColor: 'rgba(13, 187, 50, 1)',
    color: 'rgba(255, 255, 255, 1)',
  },
  [PillVariants.GOLDEN]: {
    backgroundColor: 'rgba(255, 186, 48, 1)',
    color: 'rgba(47, 47, 47, 1)',
  },
  [PillVariants.RED]: {
    backgroundColor: 'rgba(255, 71, 50, 1)',
    color: 'rgba(255, 255, 255, 1)',
  },
  [PillVariants.PURPLE]: {
    backgroundColor: 'rgba(90, 51, 254, 1)',
    color: 'rgba(255, 255, 255, 1)',
  },
  [PillVariants.GREY]: {
    backgroundColor: 'rgba(255, 255, 255, .8)',
    color: 'rgba(90, 51, 254, 1)',
  },
};
